<template>
<div>
    <base-header v-once pageName="영업활동계획" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
        <ul class="tab tab-fix" v-if="pstnTyp === 'COG01'">
            <li><button type="button" class="current">지국 영업활동계획</button></li>
            <li><button type="button" @click="memberList()">소속 조직원 계획</button></li>
        </ul>

        <ul class="bsnsAcpln-list">
            <li class="write" @click="regBsnPlan()" v-if="pstnTyp !== 'COG01' && stat != 'C' && canReq === 'Y'">
                {{planYr}}년 {{planMn}}월 영업활동계획서 작성해주세요.
            </li>

            <li v-for="item in list" v-bind:key="item.sqno || (item.planYr+item.planMn)"
                @click="bsnPlanDetail(item)">
                <h5>{{item.planYr}}년 {{item.planMn}}월</h5>
                <div>
                    <template v-if="pstnTyp === 'COG01'">
                        <span>지국 실적 목표</span>
                        <strong>{{amtSum(item) * 10000 | numFormat}}</strong>
                        <em>원</em>
                    </template>
                    <template v-else-if="pstnTyp === 'COG02'">
                        <span>지구 실적 목표</span>
                        <strong>{{item.headAmtSum * 10000 | numFormat}}</strong>
                        <em>원</em>
                        <span>개인 실적 목표</span>
                        <strong>{{amtSum(item) * 10000 | numFormat}}</strong>
                        <em>원</em>
                    </template>
                    <template v-else>
                        <span>개인 실적 목표</span>
                        <strong>{{amtSum(item) * 10000 | numFormat}}</strong>
                        <em>원</em>
                    </template>
                </div>
                <dl>
                    <template v-for="amt in item.amtList">
                        <dt v-bind:key="'dt-'+amt.cateCd">{{amt.cateNm}}</dt>
                        <dd v-bind:key="'dd-'+amt.cateCd">{{amt.goalAmt * 10000 | numFormat}}원</dd>
                    </template>
                </dl>
                <ul>
                    <li v-for="act in activityItemsOf(item)" v-bind:key="act.cateCd">
                        <em>{{act.cateNm}}</em>
                        <strong>{{act.goalCscnt}}건</strong>
                    </li>
                </ul>
                <ul v-if="counselItemsOf(item).length">
                    <li v-for="act in counselItemsOf(item)" v-bind:key="act.cateCd">
                        <em>{{act.cateNm}}</em>
                        <strong>{{act.goalCscnt}}건</strong>
                    </li>
                </ul>
            </li>
        </ul>

        <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
            <div slot="no-more"></div>
            <div slot="no-results">
                <div class="bsns-dataNone">
                    등록된 영업활동계획이 없습니다.
                </div>
            </div>
        </infinite-loading>
    </section>
</div>
</template>

<script>
// 영업활동계획(신규) 목록 — 새 테이블(TBL_SLOP_ACTV_PLAN_MST/AMT_DTL/ACT_DTL) 전용 화면.
// 기존 /mypage/bsnPlnList (BsnPlnList.vue) 는 전혀 건드리지 않는다. 우선 개인(본인) 목록만 제공.
import InfiniteLoading from "vue-infinite-loading";

// 활동목표(BPG) 중 "상담" 쪽 카테고리 코드 — 기존상담(BPG04), 신규상담(BPG05).
// DB는 ACT_DTL 하나로 합쳐져 있지만, 화면은 기획서대로 활동/상담을 줄을 나눠 보여준다.
var COUNSEL_CATE_CDS = ['BPG04', 'BPG05'];

export default {
  name: "BsnPlan2List",
  components: {
    InfiniteLoading,
  },

  data() {
    return {
      planYr: '',
      planMn: '',
      sqno: '',
      stat: '',
      list: [],
      offset: 0,
      size: 10,
      canReq: 'N',
      pstnTyp: this.$store.getters.orgnzPstn
    };
  },

  methods: {
    activityItemsOf: function(item) {
      return (item.actList || []).filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) === -1; });
    },
    counselItemsOf: function(item) {
      return (item.actList || []).filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) !== -1; });
    },

    amtSum: function(item) {
      return (item.amtList || []).reduce(function(sum, amt) {
        return sum + Number(amt.goalAmt || 0);
      }, 0);
    },

    infiniteHandler: function($state) {
      var that = this;
      var parameters = {
        offset: this.offset,
        size: this.size
      };
      this.$api.bsnPlan2
        .list(parameters)
        .then(function(data) {
          var list = data.list;
          if (list.length) {
            that.list = that.list.concat(list);
            $state.loaded();
            that.offset += that.size;

            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    regBsnPlan: function(sqno, planYr, planMn) {
      // 기존 BsnPlnList.vue 와 동일: COG06(교육생/임시)은 작성 불가
      if (this.pstnTyp === 'COG06') {
        alert("에듀플래너 이상만 작성가능합니다.");
        return;
      }
      var qYr = planYr || this.planYr;
      var qMn = planMn || this.planMn;
      this.$router.push('/bsnplan2/reg?sqno=' + (sqno || this.sqno) + '&planYr=' + qYr + '&planMn=' + qMn);
    },

    // 목록에서 항목 클릭 → 읽기 전용 상세 화면 (기존 BsnPlnList.vue 와 동일하게 네이티브 새 창)
    // 지국장(COG01)은 개인 sqno 가 없는 집계 행이라, 연/월로 상세(집계)를 조회한다 —
    // 기존 BsnPlnList.vue 가 "sqno" 파라미터에 연월을 실어보내던 것과 같은 의미.
    bsnPlanDetail: function(item) {
      if (this.pstnTyp === 'COG01') {
        this.$utils.nativeIf.outbound.newPage("/bsnplan2/detail?planYr=" + item.planYr + "&planMn=" + item.planMn);
      } else {
        this.$utils.nativeIf.outbound.newPage("/bsnplan2/detail?sqno=" + item.sqno);
      }
    },

    memberList: function() {
      this.$router.push('/bsnplan2/memberList');
    },

    bsnPlanExist: function(planYr, planMn) {
      var that = this;
      var parameters = {
        planYr: planYr,
        planMn: planMn
      };
      this.$api.bsnPlan2
        .existInfo(parameters)
        .then(function(data) {
          if (data) {
            that.sqno = data.sqno;
            that.stat = data.stat;
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    }
  },

  filters: {
    numFormat: function(num) {
      if (num == null || num == 0) return 0;

      var n = num + '';
      var reg = /(^[+-]?\d+)(\d{3})/;

      while (reg.test(n))
        n = n.replace(reg, '$1' + ',' + '$2');

      return n;
    }
  },

  created: function() {
    // 등록 가능 여부(구간 마감/시작일) 판단은 기존 영업활동계획 화면과 동일한
    // /api/v1/mypage/bsnPln/sttEndInfo 를 그대로 재사용한다 (TBL_SLOP_ACTV_PLAN 을
    // 전혀 참조하지 않는, KWKSOS 스케줄 테이블 기반의 읽기 전용 API 라 그대로 써도 안전함).
    var firstDayOfPreMon = new Date();

    var yearOfPreMon = firstDayOfPreMon.getFullYear() + '';
    var monthOfPreMon = ((firstDayOfPreMon.getMonth() + 1) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() + 1);
    var dayOfPreMon = ("00" + (firstDayOfPreMon.getDate())).slice(-2);

    var hourOfPreMon = firstDayOfPreMon.getHours();
    var minOfPreMon = firstDayOfPreMon.getMinutes();

    var nextYr = '';
    var nextMn = '';

    if ((firstDayOfPreMon.getMonth() + 2) > 12) {
      nextYr = (firstDayOfPreMon.getFullYear() + 1) + '';
      nextMn = ((firstDayOfPreMon.getMonth() - 10) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() - 10)
    } else {
      nextYr = yearOfPreMon;
      nextMn = ((firstDayOfPreMon.getMonth() + 2) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() + 2);
    }

    var that = this;
    var parameters = {
      thisYrmn: yearOfPreMon + monthOfPreMon,
      nextYrmn: nextYr + nextMn
    };
    this.$api.mypage
      .sttEndInfo(parameters)
      .then(function(data) {
        if (data.firstSttDt) {
          if (data.firstSttDt + "1200" >= yearOfPreMon + monthOfPreMon + dayOfPreMon + hourOfPreMon + minOfPreMon && data.fourthEndDt <= yearOfPreMon + monthOfPreMon + dayOfPreMon) {
            that.canReq = 'Y';
            that.planYr = nextYr;
            that.planMn = nextMn;
          }
        } else {
          // data.thisFirstSttDt 가 없으면(KSS 일정 미등록) undefined + "1200" 이
          // 문자열 "undefined1200" 이 되어 날짜 문자열과의 >= 비교에서 항상 true가
          // 되어버리는 함정이 있어, 값이 있을 때만 비교한다.
          if (data.thisFirstSttDt && data.thisFirstSttDt + "1200" >= yearOfPreMon + monthOfPreMon + dayOfPreMon + hourOfPreMon + minOfPreMon) {
            that.canReq = 'Y';
            that.planYr = yearOfPreMon;
            that.planMn = monthOfPreMon;
          }
        }

        if (data.firstEndDt && data.firstEndDt2 && data.firstEndDt <= yearOfPreMon + monthOfPreMon + dayOfPreMon && data.firstEndDt2 >= yearOfPreMon + monthOfPreMon + dayOfPreMon) {
          that.canReq = 'Y';
          that.planYr = yearOfPreMon;
          that.planMn = monthOfPreMon;
        }

        if (that.canReq == "Y") {
          that.bsnPlanExist(that.planYr, that.planMn);
        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });
  }
};
</script>
